<template>
  <v-dialog v-model="dialog.status" fullscreen hide-overlay scrollable transition="dialog-bottom-transition">
    <div class="checklist-dialog">
      <div class="header">
        <div class="return-screen" @click="returnScreen()">
          <v-icon color="white">mdi-close</v-icon>
        </div>
        <div class="history" @click="openHistoryModal()">
          <v-icon color="white">mdi-history</v-icon>
        </div>
        <h2>{{ checklist ? checklist.structure.title : 'Aguarde...' }}</h2>
        <div>{{ checklist ? checklist.structure.description : 'Carregando checklist' }}</div>
      </div>
      <div v-if="checklist && !loading" class="px-5 py-3 content">
        <div v-for="group in checklist.structure.checklist_groups" :key="group.id" class="checklist-group">
          <div class="g-title">
            <h3>{{ group.title }}</h3>
            <small>{{ group.description }}</small>
          </div>
          <div class="g-content">
            <div v-for="item in group.checklist_group_items" :key="item.id" style="background-color: #eee; margin-bottom: 15px">
              <div class="g-c-item">
                <div v-if="getVelueItem(item.id) && getVelueItem(item.id).loading">
                  <v-progress-linear :indeterminate="true" absolute color="#dbdbdb70" style="height: 100%" top></v-progress-linear>
                </div>
                <div class="g-c-i-title">
                  {{ item.title }}
                </div>
                <div v-if="checkItemLoading(item.id)" class="g-c-i-loading">NÃO DESLIGUE A TELA E NÃO FECHE O APLICATIVO</div>
                <div v-if="!checkItemHavePendingPhotos(item) && !checkItemLoading(item.id)" class="g-c-i-actions">
                  <div
                    v-bind:class="[getVelueItem(item.id) && getVelueItem(item.id).value === 'OK' ? 'checked-ok' : '', 'g-c-i-a-item']"
                    @click="checkItem(item, 'OK')"
                  >
                    <v-icon :color="getVelueItem(item.id) && getVelueItem(item.id).value === 'OK' ? 'white' : ''"> mdi-check-bold </v-icon>
                  </div>
                  <div
                    v-bind:class="[getVelueItem(item.id) && getVelueItem(item.id).value === 'CAUTION' ? 'checked-caution' : '', 'g-c-i-a-item']"
                    @click="checkItem(item, 'CAUTION')"
                  >
                    <v-icon :color="getVelueItem(item.id) && getVelueItem(item.id).value === 'CAUTION' ? 'white' : ''"> mdi-alert </v-icon>
                  </div>
                  <div
                    v-bind:class="[getVelueItem(item.id) && getVelueItem(item.id).value === 'PROBLEM' ? 'checked-problem' : '', 'g-c-i-a-item']"
                    @click="checkItem(item, 'PROBLEM')"
                  >
                    <v-icon :color="getVelueItem(item.id) && getVelueItem(item.id).value === 'PROBLEM' ? 'white' : ''"> mdi-close-octagon </v-icon>
                  </div>
                  <div
                    @click="checkItem(item, 'N/A')"
                    v-bind:class="[getVelueItem(item.id) && getVelueItem(item.id).value === 'N/A' ? 'checked-not-applicable' : '', 'g-c-i-a-item']"
                  >
                    <span class="not-applicable-label">N/A</span>
                  </div>
                </div>
                <div :class="getObservationClass(item)" @click="openChecklistDialogItemObs(item, item.title, getVelueItem(item.id))">
                  <v-icon
                    :color="
                      getVelueItem(item.id) &&
                      (getVelueItem(item.id).observation ||
                        getVelueItem(item.id).media_url ||
                        getVelueItem(item.id)?.service_order_checklist_item_medias?.length)
                        ? 'white'
                        : ''
                    "
                    size="20"
                    class="mr-2"
                  >
                    mdi-message-text
                  </v-icon>
                  <span
                    :style="{
                      color:
                        getVelueItem(item.id) &&
                        (getVelueItem(item.id).observation ||
                          getVelueItem(item.id).media_url ||
                          getVelueItem(item.id)?.service_order_checklist_item_medias?.length)
                          ? 'white'
                          : ''
                    }"
                  >
                    OBSERVAÇÕES
                  </span>
                </div>
              </div>
              <div v-if="checkItemHavePendingPhotos(item)" class="pending-photos">
                <h3 class="pp-header">Sincronização pendente</h3>
                <div v-for="pendingMedia in getItemHavePendingPhotos(item)" :key="pendingMedia.id" class="pp-media">
                  <v-progress-linear
                    v-if="pendingMedia.loading"
                    :indeterminate="true"
                    absolute
                    color="teal"
                    style="top: 6px; position: relative"
                    top
                  ></v-progress-linear>
                  <v-icon v-if="!checkItemLoading(item.id)" class="remove-image" color="red" @click="removePendingPhoto(pendingMedia.id)"
                    >mdi-trash-can</v-icon
                  >
                  <v-icon v-if="!checkItemLoading(item.id)" class="resync-image" color="green" @click="resyncMedia(item, pendingMedia)"
                    >mdi-sync</v-icon
                  >
                  <div
                    v-if="pendingMedia.media.type?.includes('video/')"
                    style="overflow: hidden; position: inherit; display: flex; align-items: center; justify-content: center"
                  >
                    <video controls style="border-radius: 5px; background-color: #000">
                      <source :src="pendingMedia.photo_url" type="video/mp4" />
                    </video>
                  </div>
                  <img v-else :src="pendingMedia.photo_url" class="align-end" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-6" style="text-align: center">
          <v-btn
            v-if="search_params.page > 0 && checklist && !search_params.no_more_results"
            :loading="loading_pagination"
            color="#e7e7e7"
            elevation="0"
            style="width: 100%"
            @click="nextPage()"
          >
            <v-icon>mdi-chevron-double-down</v-icon>
          </v-btn>
        </div>
      </div>
      <div v-if="loading" class="px-5 py-3" style="margin-top: 105px">
        <v-skeleton-loader v-for="i in 3" :key="i" class="mx-auto" height="100" style="margin-bottom: 15px" type="image"></v-skeleton-loader>
      </div>
    </div>

    <ChecklistDialogItemObs
      :dialog="dialog_item_obs"
      :is-active="dialog_item_obs.open"
      :groupMediaOrdersLoading="groupMediaOrdersLoading"
      @close="closeChecklistDialogItemObs"
      @update="updateChecklistDialogItem"
      @add-file="addFileToChecklistItem"
      @remove-file="removeFileFromChecklistItem"
      @order-loading="setGroupMediaOrdersLoading"
    />

    <!-- Modal de Histórico -->
    <v-dialog v-model="dialog_history.open" max-width="600px" persistent>
      <v-card>
        <v-card-title class="px-4 pb-4"> Histórico de Alterações </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="padding: 10px; max-height: 400px; overflow-y: auto">
          <div v-if="dialog_history.loading" class="text-center py-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <div class="mt-2">Carregando histórico...</div>
          </div>
          <div v-else-if="dialog_history.history.length === 0" class="text-center py-4">
            <v-icon size="48" color="grey lighten-1">mdi-history</v-icon>
            <div class="mt-2 text-grey">Nenhuma alteração encontrada</div>
          </div>
          <div v-else>
            <div v-for="(log, index) in dialog_history.history" :key="index" class="history-item mb-3">
              <div class="history-header">
                <div class="history-user">
                  <v-icon size="16" class="mr-1">mdi-account</v-icon>
                  <strong>{{ log.user ? log.user.name : 'Usuário não identificado' }}</strong>
                </div>
                <div class="history-date">
                  {{ formatDate(log.created_at) }}
                </div>
              </div>
              <div class="history-content">
                <div class="history-action">
                  <span>
                    <template v-if="log.action === 'observation_added' && log.old_value && log.new_value">
                      {{ getActionDescription(log.action, log.new_value, log.observation, log.old_value) }}
                    </template>
                    <template v-else>
                      {{ getActionDescription(log.action, log.new_value, log.observation, log.old_value) }}
                    </template>
                  </span>
                </div>
                <div v-if="log.item_title" class="history-item-title"><strong>Item:</strong> {{ log.item_title }}</div>
                <div v-if="log.action === 'observation_added' && log.old_value && log.new_value" class="history-observation-compare">
                  <span class="old-observation">"{{ log.old_value }}"</span>
                  <v-icon size="16" class="mx-1">mdi-arrow-right</v-icon>
                  <span class="new-observation">"{{ log.new_value }}"</span>
                </div>
                <div v-if="log.action === 'media_added' && log.old_media_url && log.new_media_url" class="history-media-compare">
                  <img :src="log.old_media_url" alt="Antiga" class="media-thumb" />
                  <v-icon size="16" class="mx-2">mdi-arrow-right</v-icon>
                  <img :src="log.new_media_url" alt="Nova" class="media-thumb" />
                </div>
                <div v-if="log.action === 'media_added' && log.new_media_url && !log.old_media_url" class="history-media-compare">
                  <span class="mr-2">Nova imagem:</span>
                  <img :src="log.new_media_url" alt="Nova" class="media-thumb" />
                </div>
                <div v-if="log.observation && log.action !== 'observation_added'" class="history-observation">
                  <strong>Observação:</strong> {{ log.observation }}
                </div>
              </div>
            </div>

            <!-- Controles de Paginação -->
            <div v-if="dialog_history.pagination && dialog_history.pagination.totalPages > 1" class="pagination-controls mt-4">
              <v-divider class="mb-3"></v-divider>
              <div class="d-flex justify-space-between align-center">
                <div class="pagination-info">
                  <small class="text-grey ml-2">
                    Página {{ dialog_history.pagination.page }} de {{ dialog_history.pagination.totalPages }} ({{ dialog_history.pagination.total }}
                    registros)
                  </small>
                </div>
                <div class="pagination-buttons">
                  <v-btn :disabled="dialog_history.pagination.page <= 1" icon small @click="changePage(dialog_history.pagination.page - 1)">
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                  <span class="mx-2">{{ dialog_history.pagination.page }}</span>
                  <v-btn
                    :disabled="dialog_history.pagination.page >= dialog_history.pagination.totalPages"
                    icon
                    small
                    @click="changePage(dialog_history.pagination.page + 1)"
                  >
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" outlined block depressed @click="closeHistoryModal"> Fechar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
// TODO: DELETAR CHECKLIST;
import dexieDB from '@/services/dexieService';
import { startLocationTracking, appendMetadataToFormData, getMetadataForJson } from '@/services/mediaMetadata';
import ChecklistDialogItemObs from './ChecklistDialogItemObs';

export default {
  name: 'ChecklistDialog',
  components: {
    ChecklistDialogItemObs
  },
  props: {
    dialog: Object
  },
  data: () => ({
    loading: true,
    loading_pagination: true,
    checklist: null,
    localCounters: {
      checked: 0,
      ok: 0,
      caution: 0,
      problem: 0,
      not_applicable: 0
    },
    dialog_item_obs: {
      open: false,
      item: null,
      value: null
    },
    dialog_history: {
      open: false,
      loading: false,
      history: [],
      pagination: null
    },
    loading_itens: [],
    pending_photos: [],
    search_params: {
      page: 1,
      no_more_results: false
    },
    groupMediaOrdersLoading: []
  }),
  computed: {
    status() {
      return this.$store.getters['ServiceOrder/status'];
    },
    parameterMediaBackupHours() {
      return this.$store.getters['Auth/parameters']?.find((parameter) => parameter.name === 'media_backup_hours_stored')?.value;
    },
    isMultipleUpload() {
      let isMultiple = true;

      if (this.getOrganizationParameter('DISABLE_MEDIA_MULTIPLE_UPLOADS')) {
        isMultiple = false;
      }

      return isMultiple;
    }
  },
  mounted() {
    startLocationTracking();
    this.checklist = null;
    this.localCounters = {
      checked: this.dialog.checked_itens || 0,
      ok: this.dialog.checked_itens_ok || 0,
      caution: this.dialog.checked_itens_caution || 0,
      problem: this.dialog.checked_itens_problem || 0,
      not_applicable: this.dialog.checked_itens_not_applicable || 0
    };
    this.getChecklistDetails();
    this.checkBackupMedias();
  },
  methods: {
    getChecklistDetails() {
      const self = this;

      if (!self.checklist) {
        self.loading = true;
      } else {
        self.loading_pagination = true;
      }

      self.$http
        .get(`/checklist/${self.dialog.checklist_id}/service_order/${self.dialog.service_order_id}`, {
          params: {
            page: this.search_params.page,
            group_size: 1
          }
        })
        .then((response) => {
          if (!this.checklist) {
            self.checklist = response.data;
          } else {
            const checklistGroups = response?.data?.structure?.checklist_groups ?? [];
            const serviceOrderChecklistItems = response?.data?.values.service_order_checklist_items ?? [];

            self.checklist.structure.checklist_groups.push(...checklistGroups);
            self.checklist.values.service_order_checklist_items.push(...serviceOrderChecklistItems);

            if (!checklistGroups.length && !serviceOrderChecklistItems.length) {
              this.search_params.no_more_results = true;
            }
          }
        })
        .finally(() => {
          self.loading = false;
          self.loading_pagination = false;
        });
    },
    nextPage() {
      this.search_params.page += 1;
      this.getChecklistDetails();
    },
    getVelueItem(id) {
      return this.checklist.values.service_order_checklist_items.find((item) => item.checklist_group_items_id === id);
    },
    returnScreen() {
      this.$emit('return', {
        checklistId: this.checklist?.structure?.id,
        counters: { ...this.localCounters }
      });
    },
    checkItem(find, value) {
      const self = this;
      if (self.status === 'finished' || self.status === 'canceled') {
        return;
      }
      const valueIndex = self.checklist.values.service_order_checklist_items.findIndex((item) => item.checklist_group_items_id === find.id);
      const existingItem = self.checklist.values.service_order_checklist_items[valueIndex];

      if (existingItem) {
        if (existingItem.value === value) {
          self.uncheckItemRequest(valueIndex, find.id);
        } else {
          self.checkItemRequest(valueIndex, value, find.id);
        }
      } else {
        self.checkItemRequest(valueIndex, value, find.id);
      }
    },
    updateValueCounter(oldValue, newValue) {
      const counterMap = { OK: 'ok', CAUTION: 'caution', PROBLEM: 'problem', 'N/A': 'not_applicable' };
      if (oldValue && counterMap[oldValue] !== undefined) this.localCounters[counterMap[oldValue]] -= 1;
      if (newValue && counterMap[newValue] !== undefined) this.localCounters[counterMap[newValue]] += 1;
    },
    checkItemRequest(valueIndex, value, itemId) {
      const self = this;
      const oldValue = valueIndex >= 0 ? self.checklist.values.service_order_checklist_items[valueIndex]?.value : null;
      if (valueIndex >= 0) {
        self.$set(self.checklist.values.service_order_checklist_items[valueIndex], 'loading', true);
      }
      self.$http
        .patch(`/service_order/${self.dialog.service_order_id}/checklist/${self.checklist.values.id}/upsert`, {
          value,
          item_id: itemId
        })
        .then((response) => {
          if (valueIndex >= 0) {
            // Mudando valor de um item já marcado: decrementa antigo, incrementa novo
            self.updateValueCounter(oldValue, value);
            self.$set(self.checklist.values.service_order_checklist_items[valueIndex], 'value', value);
            self.$set(self.checklist.values.service_order_checklist_items[valueIndex], 'loading', false);
          } else {
            // Novo item marcado: incrementa total e o status correspondente
            self.localCounters.checked += 1;
            self.updateValueCounter(null, value);
            self.checklist.values.service_order_checklist_items.push(response.data.service_order_checklist_item);
          }
        })
        .catch(() => {
          if (valueIndex >= 0) {
            self.$set(self.checklist.values.service_order_checklist_items[valueIndex], 'loading', false);
          }
        });
    },
    uncheckItemRequest(valueIndex, itemId) {
      const self = this;
      const oldValue = self.checklist.values.service_order_checklist_items[valueIndex]?.value;
      if (valueIndex >= 0) {
        self.$set(self.checklist.values.service_order_checklist_items[valueIndex], 'loading', true);
      }
      self.$http
        .patch(`/service_order/${self.dialog.service_order_id}/checklist/${self.checklist.values.id}/uncheck`, {
          item_id: itemId
        })
        .then(() => {
          // Item desmarcado: decrementa total e o status que tinha
          self.localCounters.checked -= 1;
          self.updateValueCounter(oldValue, null);
          self.checklist.values.service_order_checklist_items.splice(valueIndex, 1);
        })
        .catch(() => {
          if (valueIndex >= 0) {
            self.$set(self.checklist.values.service_order_checklist_items[valueIndex], 'loading', false);
          }
        });
    },
    openChecklistDialogItemObs(item, description, value) {
      this.dialog_item_obs = {
        open: false,
        service_order_id: this.dialog.service_order_id,
        checklist_id: this.dialog.checklist_id,
        editable: this.status !== 'finished',
        item,
        description,
        value
      };
      this.dialog_item_obs.open = true;
    },
    closeChecklistDialogItemObs(updatedItemValue) {
      if (updatedItemValue) {
        const valueIndex = this.checklist.values.service_order_checklist_items.findIndex((item) => item.id === updatedItemValue.id);
        if (valueIndex !== -1) {
          this.checklist.values.service_order_checklist_items[valueIndex].observation = updatedItemValue.observation;
        }
      }
      this.dialog_item_obs = {
        open: false,
        item: null
      };
    },
    getObservationClass(item) {
      const itemValue = this.getVelueItem(item.id);

      let className = 'g-c-i-a-observation';
      if (!itemValue) {
        className += ' disabled';
      } else if (itemValue && (itemValue.observation || itemValue.media_url || itemValue?.service_order_checklist_item_medias?.length)) {
        className += ' checked-observation';
      }
      return className;
    },
    updateChecklistDialogItem(updatedItemValue) {
      const self = this;
      const valueIndex = self.checklist.values.service_order_checklist_items.findIndex((item) => item.id === updatedItemValue.id);

      if (!valueIndex && valueIndex !== 0) {
        return;
      }

      self.$set(self.checklist.values.service_order_checklist_items, valueIndex, updatedItemValue);
    },
    async addFileToChecklistItem(dialog, formData, media, positionInfo) {
      const self = this;

      const newInfos = JSON.parse(JSON.stringify(dialog));

      const type = 'checklist';
      const tag = `checklist_${newInfos.value.service_order_checklist_id}_item_${newInfos.value.id}_${positionInfo.order ?? 1}${
        positionInfo?.position === 'second' ? '_second' : ''
      }`;

      if (self.isMultipleUpload && !media.type.includes('image')) {
        try {
          await self.uploadMediaMultipartCreate(dialog, newInfos, media, type, tag);
        } finally {
          const orderIndex = this.groupMediaOrdersLoading.findIndex((o) => o === positionInfo.order);
          if (orderIndex !== -1) this.groupMediaOrdersLoading.splice(orderIndex, 1);
        }
        return;
      }

      self.loading_itens.push(dialog.item.id);

      const bkpPhotoId = await self.localBackupMedia(newInfos, media, type, tag, false);

      appendMetadataToFormData(formData);

      try {
        const response = await self.$http.post(
          `/service_order/${newInfos.service_order_id}/checklist/${newInfos.value.service_order_checklist_id}/item/${newInfos.value.id}/media?type=${type}&tag=${tag}&v2=true`,
          formData,
          {
            timeout: 1000 * 120,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        if (
          this?.dialog_item_obs?.value?.id === response.data.service_order_checklist_item_media.service_order_checklist_item_id &&
          this.dialog_item_obs?.value?.service_order_checklist_item_medias
        ) {
          this.dialog_item_obs.value.service_order_checklist_item_medias.push(response.data.service_order_checklist_item_media);
        } else if (
          this?.dialog_item_obs?.value?.id === response.data.service_order_checklist_item_media.service_order_checklist_item_id &&
          !this.dialog_item_obs?.value?.service_order_checklist_item_medias
        ) {
          this.dialog_item_obs.value = {
            ...this.dialog_item_obs.value,
            service_order_checklist_item_medias: [response.data.service_order_checklist_item_media]
          };
        }

        const valueIndex = this.checklist.values.service_order_checklist_items.findIndex(
          (item) => item.id === response.data.service_order_checklist_item_media.service_order_checklist_item_id
        );
        if (valueIndex !== -1 && this.checklist.values?.service_order_checklist_items?.[valueIndex]?.service_order_checklist_item_medias) {
          this.checklist.values.service_order_checklist_items[valueIndex].service_order_checklist_item_medias.push(
            response.data.service_order_checklist_item_media
          );
        } else if (valueIndex !== -1 && !this.checklist.values?.service_order_checklist_items?.[valueIndex]?.service_order_checklist_item_medias) {
          this.checklist.values.service_order_checklist_items[valueIndex] = {
            ...this.checklist.values.service_order_checklist_items[valueIndex],
            service_order_checklist_item_medias: [response.data.service_order_checklist_item_media]
          };
        }

        // if (this.parameterMediaBackupHours) {
        //   await dexieDB.removeAttemptsServiceOrderChecklistItem(bkpPhotoId);
        // }

        // if (!this.parameterMediaBackupHours) {
        await dexieDB.removeServiceOrderChecklistItemPhoto(bkpPhotoId);
        // }
      } catch (err) {
        console.log(err);
        self.checkBackupMedias();
      } finally {
        self.loading_itens = self.loading_itens.filter((item) => item !== dialog.item.id);

        const orderIndex = this.groupMediaOrdersLoading.findIndex((o) => o === positionInfo.order);
        if (orderIndex !== -1) this.groupMediaOrdersLoading.splice(orderIndex, 1);
      }
    },
    removeFileFromChecklistItem(itemValueId, mediaId, isFromMediaUrl = false) {
      const value = this.checklist.values.service_order_checklist_items.find((item) => item.id === itemValueId);

      if (!value) return;

      if (isFromMediaUrl) {
        value.media_url = null;
        return;
      }

      const mediaIndex = value.service_order_checklist_item_medias.findIndex((m) => m.id === mediaId);

      if (mediaIndex === -1) return;

      value.service_order_checklist_item_medias.splice(mediaIndex, 1);
    },
    async uploadMediaMultipartCreate(dialog, newInfos, file, type, tag, resync = false) {
      const self = this;

      self.loading_itens.push(dialog.item.id);

      let useMultipart = true;

      if (self.getOrganizationParameter('DISABLE_MEDIA_MULTIPLE_UPLOADS')) {
        useMultipart = false;
      }

      let bkpPhotoId = null;

      try {
        let fileName = file.name;
        if (!fileName || fileName === 'photo.png' || fileName === 'assinatura.png') {
          const timestamp = Date.now();
          const extension = file.type.includes('video/') ? 'mp4' : 'jpg';
          fileName = `${tag}_${timestamp}.${extension}`;
        }

        if (!resync) {
          bkpPhotoId = await self.localBackupMedia(newInfos, file, type, tag, false);
        }

        if (useMultipart) {
          const response = await self.$http.post(
            `/service_order/${newInfos.service_order_id}/checklist/${newInfos.value.service_order_checklist_id}/item/${newInfos.value.id}/create-multipart-upload?type=${type}&tag=${tag}`,
            {
              key: fileName,
              contentType: file.type,
              usePresignedMultipart: true,
              fileSize: file.size
            }
          );

          try {
            await self.uploadMediaMultipartWithPresignedUrls(dialog, newInfos, file, response.data, type, tag, resync, bkpPhotoId);
          } catch (multipartError) {
            console.error('Erro no upload multipart, tentando via backend:', multipartError);
            await self.uploadViaBackend(dialog, newInfos, file, type, tag, resync, bkpPhotoId);
          }
        } else {
          const response = await self.$http.post(
            `/service_order/${newInfos.service_order_id}/checklist/${newInfos.value.service_order_checklist_id}/item/${newInfos.value.id}/create-multipart-upload?type=${type}&tag=${tag}`,
            {
              key: fileName,
              contentType: file.type
            }
          );

          try {
            await self.uploadDirectToS3(
              dialog,
              newInfos,
              file,
              response.data.uploadUrl,
              response.data.key,
              response.data.contentType,
              type,
              tag,
              resync,
              bkpPhotoId
            );
          } catch (corsError) {
            console.error('Erro no upload direto para S3, tentando via backend:', corsError);
            await self.uploadViaBackend(dialog, newInfos, file, type, tag, resync, bkpPhotoId);
          }
        }
      } catch (error) {
        this.loading_itens = this.loading_itens.filter((item) => item !== dialog.item.id);
        this.checkBackupMedias();

        throw new Error(`Falha ao criar upload: ${error.message}`);
      } finally {
        this.loading_itens = this.loading_itens.filter((item) => item !== dialog.item.id);
      }
    },
    async uploadMediaMultipart(newInfos, file, tag, uploadId, key) {
      const partSize = 5 * 1024 * 1024;
      const parts = [];

      try {
        const uploadPromises = [];

        for (let start = 0; start < file.size; start += partSize) {
          const end = Math.min(start + partSize, file.size);
          const part = file.slice(start, end);

          const partNumber = Math.floor(start / partSize) + 1;
          const formData = new FormData();
          formData.append('key', key);
          formData.append('partNumber', `${partNumber}`);
          formData.append('uploadId', uploadId);
          formData.append('filePart', part);

          uploadPromises.push(
            this.$http
              .post(
                `/service_order/${newInfos.service_order_id}/checklist/${newInfos.value.service_order_checklist_id}/item/${newInfos.value.id}/upload-part`,
                formData,
                {
                  timeout: 1000 * 120,
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
              )
              .then((response) => ({
                ETag: response.data.ETag,
                PartNumber: partNumber
              }))
          );
        }

        const uploadedParts = await Promise.all(uploadPromises);

        parts.push(...uploadedParts);
        parts.sort((a, b) => a.PartNumber - b.PartNumber);

        return this.$http.post(
          `/service_order/${newInfos.service_order_id}/checklist/${newInfos.value.service_order_checklist_id}/item/${newInfos.value.id}/complete-multipart-upload`,
          {
            key,
            uploadId,
            parts,
            type: file.type,
            tag,
            ...getMetadataForJson()
          }
        );
      } catch (error) {
        throw new Error(`Falha ao fazer upload das partes: ${error.message}`);
      }
    },

    async uploadMediaMultipartWithPresignedUrls(dialog, newInfos, file, uploadData, type, tag, resync, bkpPhotoId) {
      const self = this;

      if (!uploadData || typeof uploadData !== 'object') {
        throw new Error('Dados de upload inválidos recebidos do servidor');
      }

      const { UploadId, Key, partUrls, partSize } = uploadData;

      if (!UploadId || !Key || !Array.isArray(partUrls) || !partSize) {
        console.error('Estrutura de uploadData inválida:', uploadData);
        throw new Error('Estrutura de dados de upload incompleta. Verifique se o backend está retornando UploadId, Key, partUrls (array) e partSize');
      }

      for (let i = 0; i < partUrls.length; i += 1) {
        const partUrl = partUrls[i];
        if (!partUrl || !partUrl.uploadUrl || !partUrl.partNumber) {
          console.error(`Item ${i} do partUrls é inválido:`, partUrl);
          throw new Error(`Item ${i} do partUrls não tem a estrutura esperada (uploadUrl e partNumber necessários)`);
        }
      }

      try {
        const uploadPromises = partUrls.map(async (partUrl) => {
          const start = (partUrl.partNumber - 1) * partSize;
          const end = Math.min(start + partSize, file.size);
          const partData = file.slice(start, end);

          const uploadResponse = await fetch(partUrl.uploadUrl, {
            method: 'PUT',
            body: partData,
            headers: {
              'Content-Length': partData.size.toString()
            }
          });

          if (!uploadResponse.ok) {
            throw new Error(`Erro no upload da parte ${partUrl.partNumber}: ${uploadResponse.status}`);
          }

          const etag = uploadResponse.headers.get('ETag');

          return {
            ETag: etag,
            PartNumber: partUrl.partNumber
          };
        });

        const parts = await Promise.all(uploadPromises);

        parts.sort((a, b) => a.PartNumber - b.PartNumber);

        await self.uploadMediaMultipartFinish(dialog, newInfos, file, parts, type, tag, Key, UploadId, resync, bkpPhotoId);
      } catch (error) {
        console.log(error);
        self.loading_itens = self.loading_itens.filter((item) => item !== dialog.item.id);
        throw new Error(`Falha no upload multipart com URLs pré-assinadas: ${error.message}`);
      }
    },

    async uploadMediaMultipartFinish(dialog, newInfos, file, parts, type, tag, key, uploadId, resync, bkpPhotoId) {
      try {
        const response = await this.$http.post(
          `/service_order/${newInfos.service_order_id}/checklist/${newInfos.value.service_order_checklist_id}/item/${newInfos.value.id}/complete-multipart-upload?v2=true`,
          {
            key,
            uploadId,
            parts,
            type: file.type,
            tag,
            ...getMetadataForJson()
          }
        );

        let mediaData = null;
        let itemId = null;

        if (response.data.service_order_checklist_item_media) {
          mediaData = response.data.service_order_checklist_item_media;
          itemId = mediaData.service_order_checklist_item_id;
        } else if (response.data.service_order_checklist_item) {
          const item = response.data.service_order_checklist_item;
          itemId = item.id;

          if (item.media_url) {
            mediaData = {
              id: Date.now(),
              service_order_checklist_item_id: item.id,
              tag,
              media_url: item.media_url,
              type: file.type,
              created_at: item.created_at || new Date().toISOString(),
              active: 1
            };
          }
        }

        if (this?.dialog_item_obs?.value?.id === itemId && mediaData) {
          if (this.dialog_item_obs.value.service_order_checklist_item_medias) {
            this.dialog_item_obs.value.service_order_checklist_item_medias.push(mediaData);
          } else {
            this.dialog_item_obs.value = {
              ...this.dialog_item_obs.value,
              service_order_checklist_item_medias: [mediaData]
            };
          }
        }

        const valueIndex = this.checklist.values.service_order_checklist_items.findIndex((item) => item.id === itemId);
        if (valueIndex !== -1 && mediaData) {
          if (this.checklist.values.service_order_checklist_items[valueIndex].service_order_checklist_item_medias) {
            this.checklist.values.service_order_checklist_items[valueIndex].service_order_checklist_item_medias.push(mediaData);
          } else {
            this.checklist.values.service_order_checklist_items[valueIndex] = {
              ...this.checklist.values.service_order_checklist_items[valueIndex],
              service_order_checklist_item_medias: [mediaData]
            };
          }
        }

        if (!resync && bkpPhotoId) {
          await dexieDB.removeServiceOrderChecklistItemPhoto(bkpPhotoId);
        }
      } catch (error) {
        throw new Error(`Falha ao finalizar upload multipart: ${error.message}`);
      }
    },

    async uploadDirectToS3(dialog, newInfos, file, uploadUrl, key, contentType, type, tag, resync, bkpPhotoId) {
      const self = this;

      try {
        const uploadResponse = await fetch(uploadUrl, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': contentType || file.type
          }
        });

        if (!uploadResponse.ok) {
          throw new Error(`Erro no upload para S3: ${uploadResponse.status}`);
        }

        const confirmResponse = await self.$http.post(
          `/service_order/${newInfos.service_order_id}/checklist/${newInfos.value.service_order_checklist_id}/item/${newInfos.value.id}/complete-multipart-upload`,
          {
            key,
            type: file.type,
            tag,
            ...getMetadataForJson()
          }
        );

        if (this?.dialog_item_obs?.value?.id === confirmResponse.data.service_order_checklist_item_media?.service_order_checklist_item_id) {
          if (this.dialog_item_obs.value.service_order_checklist_item_medias) {
            this.dialog_item_obs.value.service_order_checklist_item_medias.push(confirmResponse.data.service_order_checklist_item_media);
          } else {
            this.dialog_item_obs.value = {
              ...this.dialog_item_obs.value,
              service_order_checklist_item_medias: [confirmResponse.data.service_order_checklist_item_media]
            };
          }
        }

        const valueIndex = this.checklist.values.service_order_checklist_items.findIndex(
          (item) => item.id === confirmResponse.data.service_order_checklist_item_media?.service_order_checklist_item_id
        );
        if (valueIndex !== -1) {
          if (this.checklist.values.service_order_checklist_items[valueIndex].service_order_checklist_item_medias) {
            this.checklist.values.service_order_checklist_items[valueIndex].service_order_checklist_item_medias.push(
              confirmResponse.data.service_order_checklist_item_media
            );
          } else {
            this.checklist.values.service_order_checklist_items[valueIndex] = {
              ...this.checklist.values.service_order_checklist_items[valueIndex],
              service_order_checklist_item_medias: [confirmResponse.data.service_order_checklist_item_media]
            };
          }
        }

        if (!resync && bkpPhotoId) {
          await dexieDB.removeServiceOrderChecklistItemPhoto(bkpPhotoId);
        }
      } catch (error) {
        throw new Error(`Falha no upload direto: ${error.message}`);
      }
    },

    async uploadViaBackend(dialog, newInfos, file, type, tag, resync = false, bkpPhotoId = null) {
      const self = this;

      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('tag', tag);
        formData.append('type', file.type);
        appendMetadataToFormData(formData);

        if (!resync && !bkpPhotoId) {
          bkpPhotoId = await self.localBackupMedia(newInfos, file, type, tag, false);
        }

        const response = await self.$http.post(
          `/service_order/${newInfos.service_order_id}/checklist/${newInfos.value.service_order_checklist_id}/item/${newInfos.value.id}/media?type=${type}&tag=${tag}`,
          formData,
          {
            timeout: 1000 * 180,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        if (this?.dialog_item_obs?.value?.id === response.data.service_order_checklist_item.id) {
          this.dialog_item_obs.value = { ...dialog.value, media_url: response.data.service_order_checklist_item.media_url };
        }

        this.updateChecklistDialogItem(response.data.service_order_checklist_item);

        if (!resync && bkpPhotoId) {
          await dexieDB.removeServiceOrderChecklistItemPhoto(bkpPhotoId);
        }
      } catch (error) {
        throw new Error(`Falha no upload via backend: ${error.message}`);
      } finally {
        this.loading_itens = this.loading_itens.filter((item) => item !== dialog.item.id);
      }
    },

    async resyncMedia(item, pendingMedia) {
      this.loading_itens.push(item.id);

      try {
        const formData = new FormData();
        formData.append('file', pendingMedia.media);
        appendMetadataToFormData(formData);

        const response = await this.$http.post(
          `/service_order/${this.dialog.service_order_id}/checklist/${this.dialog.checklist_id}/item/${pendingMedia.checklist_item_value}/media?type=${pendingMedia.type}&tag=${pendingMedia.tag}&v2=true`,
          formData,
          {
            timeout: 1000 * 120,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        if (
          this?.dialog_item_obs?.value?.id === response.data.service_order_checklist_item_media.service_order_checklist_item_id &&
          this.dialog_item_obs?.value?.service_order_checklist_item_medias
        ) {
          this.dialog_item_obs.value.service_order_checklist_item_medias.push(response.data.service_order_checklist_item_media);
        } else if (
          this?.dialog_item_obs?.value?.id === response.data.service_order_checklist_item_media.service_order_checklist_item_id &&
          !this.dialog_item_obs?.value?.service_order_checklist_item_medias
        ) {
          this.dialog_item_obs.value = {
            ...this.dialog_item_obs.value,
            service_order_checklist_item_medias: [response.data.service_order_checklist_item_media]
          };
        }

        const valueIndex = this.checklist.values.service_order_checklist_items.findIndex(
          (item) => item.id === response.data.service_order_checklist_item_media.service_order_checklist_item_id
        );
        if (valueIndex !== -1 && this.checklist.values?.service_order_checklist_items?.[valueIndex]?.service_order_checklist_item_medias) {
          this.checklist.values.service_order_checklist_items[valueIndex].service_order_checklist_item_medias.push(
            response.data.service_order_checklist_item_media
          );
        } else if (valueIndex !== -1 && !this.checklist.values?.service_order_checklist_items?.[valueIndex]?.service_order_checklist_item_medias) {
          this.checklist.values.service_order_checklist_items[valueIndex] = {
            ...this.checklist.values.service_order_checklist_items[valueIndex],
            service_order_checklist_item_medias: [response.data.service_order_checklist_item_media]
          };
        }

        await dexieDB.removeServiceOrderChecklistItemPhoto(pendingMedia.id);

        this.checkBackupMedias();
      } finally {
        const itemIndex = this.loading_itens.findIndex((item) => item !== item.id);
        this.loading_itens.splice(itemIndex, 1);
      }
    },
    async localBackupMedia(newInfos, media, type, tag, reloadBackupMedias = true) {
      const newServiceOrderPhoto = {
        service_order: this.dialog.service_order_id,
        checklist: this.dialog.checklist_id,
        checklist_item: newInfos.item.id,
        checklist_item_value: newInfos.value.id,
        type,
        tag,
        media,
        created_at: new Date().toISOString(),
        attempts: 1
      };

      try {
        const createdId = await dexieDB.addServiceOrderChecklistItemPhoto(newServiceOrderPhoto);
        if (reloadBackupMedias) {
          this.checkBackupMedias(this.service_order);
        }
        return createdId;
      } catch (err) {
        console.error('Erro ao adicionar o registro:', err);
        throw err;
      }
    },
    checkBackupMedias() {
      dexieDB.checkPendingServiceOrderChecklistItemsPhoto(this.dialog.service_order_id, this.dialog.checklist_id).then((pendingPhotos) => {
        this.pending_photos = pendingPhotos.filter(({ attempts }) => attempts);
        this.pending_photos.forEach((photo) => {
          photo.photo_url = URL.createObjectURL(photo.media);
        });
      });
    },
    checkItemLoading(itemId) {
      return this.loading_itens.includes(itemId);
    },
    checkItemHavePendingPhotos(item) {
      return this.pending_photos.find(({ checklist_item: checklistItem }) => checklistItem === item.id);
    },
    getItemHavePendingPhotos(item) {
      return this.pending_photos.filter(({ checklist_item: checklistItem }) => checklistItem === item.id);
    },
    async removePendingPhoto(id) {
      await dexieDB.removeServiceOrderChecklistItemPhoto(id);
      this.checkBackupMedias();
    },
    getOrganizationParameter(code) {
      const user = this.$store.getters['Auth/user'];
      const search = user.organization.organization_parameters.find((parameter) => parameter.code === code);
      return search ? search.value : false;
    },
    openHistoryModal() {
      this.dialog_history.open = true;
      this.dialog_history.pagination = {
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 0
      };
      this.getHistory();
    },
    async getHistory() {
      this.dialog_history.loading = true;
      try {
        const params = {
          page: this.dialog_history.pagination?.page || 1,
          limit: 10
        };

        const response = await this.$http.get(`/service_order/${this.dialog.service_order_id}/checklist/${this.dialog.checklist_id}/history`, {
          params
        });

        if (response.data.data && response.data.pagination) {
          this.dialog_history.history = response.data.data;
          this.dialog_history.pagination = response.data.pagination;
        } else {
          this.dialog_history.history = response.data;
          this.dialog_history.pagination = null;
        }
      } catch (error) {
        console.error('Erro ao carregar histórico:', error);
        this.dialog_history.history = [];
        this.dialog_history.pagination = null;
      } finally {
        this.dialog_history.loading = false;
      }
    },
    closeHistoryModal() {
      this.dialog_history.open = false;
      this.dialog_history.history = [];
      this.dialog_history.pagination = null;
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    getActionDescription(action, newValue = null, observation = null, oldValue = null) {
      const normalizedValue = newValue === null || newValue === '' ? 'N/A' : newValue;
      const normalizedOldValue = oldValue === null || oldValue === '' ? 'N/A' : oldValue;
      const valueLabel = this.getValueLabel(normalizedValue);
      const oldValueLabel = this.getValueLabel(normalizedOldValue);

      const descriptions = {
        created: 'Item criado',
        updated: `Item atualizado de "${oldValueLabel}" para "${valueLabel}"`,
        deleted: 'Item removido',
        checked: `Marcou "${valueLabel}" no item`,
        unchecked: 'Desmarcou o item',
        observation_added: observation ? `Observação: ${observation}` : 'Observação',
        media_added: 'Mídia alterada'
      };
      return descriptions[action] || 'Ação realizada';
    },
    getValueLabel(value) {
      if (value === null || value === undefined) {
        return 'N/A';
      }

      const labels = {
        OK: 'OK',
        CAUTION: 'ATENÇÃO',
        PROBLEM: 'PROBLEMA',
        'N/A': 'N/A',
        null: 'N/A'
      };
      return labels[value] || value;
    },
    changePage(page) {
      this.dialog_history.pagination.page = page;
      this.getHistory();
    },
    setGroupMediaOrdersLoading(order) {
      this.groupMediaOrdersLoading.push(order);
    }
  }
};
</script>

<style lang="scss">
.checklist-dialog {
  .header {
    position: fixed;
    width: 100%;
    z-index: 99;
    padding: 20px 20px;
    background-color: #3e515f;
    color: #fff;

    h2,
    div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .return-screen {
      float: right;
      background-color: #2d3c47;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
    }

    .history {
      float: right;
      background-color: #2d3c47;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
      margin-right: 10px;
    }
  }

  .content {
    margin-top: 110px;
  }

  .checklist-group {
    margin-bottom: 10px;

    .g-title {
      line-height: 22px;
      font-size: 19px;
    }

    .g-content {
      border-top: 1px solid #eee;
      margin-top: 5px;
      padding-top: 10px;

      .g-c-item {
        background-color: #eee;
        border-radius: 5px;
        overflow: hidden;
        padding: 10px;
        position: relative;

        .g-c-i-title {
          border-bottom: 1px solid #dddddd;
          padding-bottom: 7px;
        }

        .g-c-i-actions {
          padding-top: 10px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;

          .g-c-i-a-item {
            margin: 0px 10px;
            background-color: #fff;
            border: 2px solid #fff;
            border-radius: 5px;
            padding: 5px 0px;
            width: 18%;
            text-align: center;

            &.disabled {
              pointer-events: none;
              opacity: 0.6;
            }

            &.checked-ok {
              border: 2px solid #3d9b78;
              background-color: #48b38b;
            }

            &.checked-caution {
              border: 2px solid #cc6f1e;
              background-color: #ff8517;
            }

            &.checked-problem {
              border: 2px solid #b82121;
              background-color: #ff1f1f;
            }

            &.checked-not-applicable {
              border: 2px solid #465864;
              background-color: #4f6d82;

              span {
                color: white;
              }
            }

            .not-applicable-label {
              font-weight: 600;
            }

            .v-input--selection-controls__input {
              margin-right: 0px;
            }
          }
        }

        .g-c-i-a-observation {
          margin: 15px 10px 0 10px;
          background-color: #fff;
          border: 2px solid #fff;
          border-radius: 5px;
          padding: 5px 0px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;

          &.checked-observation {
            border: 2px solid #465864;
            background-color: #2d3c47;
          }

          &.disabled {
            pointer-events: none;
            opacity: 0.6;
          }
        }

        .g-c-i-loading {
          height: 39px;
          margin-top: 10px;
          background-color: red;
          border-radius: 5px;
          border: 2px solid #c30000;
          background-color: #ff0000;
          color: #fff;
          font-size: 13px;
          padding-top: 8px;
          text-align: center;
        }
      }

      .pending-photos {
        color: #fff;
        background-color: #e57373;
        border: 3px solid red !important;
        border-radius: 6px;
        margin: 3px 15px 0 15px;
        display: flex;
        padding: 3px 0;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .pp-header {
          text-align: center;
          text-transform: uppercase;
        }

        .pp-media {
          margin-top: 5px;
          margin-bottom: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          img {
            width: 98%;
            border-radius: 6px;
          }

          video {
            width: 98%;
          }
        }

        .resync-image {
          background-color: #fff;
          border-radius: 50%;
          position: absolute !important;
          right: 5px;
          top: 0;
          margin: 10px;
          padding: 6px;
          font-size: 24px !important;
          z-index: 2;
        }

        .remove-image {
          background-color: #fff;
          border-radius: 50%;
          position: absolute !important;
          left: 5px;
          top: 0;
          width: 36px;
          margin: 10px;
          padding: 6px;
          font-size: 24px !important;
          z-index: 2;
        }
      }
    }
  }
}

.history-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
  background-color: #fafafa;

  .history-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;

    .history-user {
      display: flex;
      align-items: center;
      font-size: 14px;
      max-width: 60%;
      overflow: hidden;

      strong {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .history-date {
      font-size: 12px;
      color: #666;
    }
  }

  .history-content {
    .history-action {
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      font-weight: 500;

      .v-icon {
        flex-shrink: 0;
      }
    }

    .history-item-title {
      margin-bottom: 6px;
      font-size: 13px;
      color: #555;
    }

    .history-values {
      margin-bottom: 6px;

      .value-change {
        display: flex;
        align-items: center;
        font-size: 13px;

        .old-value {
          background-color: #ffebee;
          color: #c62828;
          padding: 2px 6px;
          border-radius: 4px;
          font-weight: 500;
        }

        .new-value {
          background-color: #e8f5e8;
          color: #2e7d32;
          padding: 2px 6px;
          border-radius: 4px;
          font-weight: 500;
        }
      }
    }

    .history-observation {
      font-size: 13px;
      color: #555;
      font-style: italic;
      background-color: #f5f5f5;
      padding: 6px;
      border-radius: 4px;
      border-left: 3px solid #2196f3;
    }

    .history-observation-compare {
      margin-bottom: 6px;
      font-size: 13px;
      color: #555;
      font-style: italic;
      background-color: #f5f5f5;
      padding: 6px;
      border-radius: 4px;
      border-left: 3px solid #2196f3;

      .old-observation {
        background-color: #ffebee;
        color: #c62828;
        padding: 2px 6px;
        border-radius: 4px;
        font-weight: 500;
      }

      .new-observation {
        background-color: #e8f5e8;
        color: #2e7d32;
        padding: 2px 6px;
        border-radius: 4px;
        font-weight: 500;
      }
    }

    .history-media-compare {
      margin-bottom: 6px;
      font-size: 13px;
      color: #555;
      font-style: italic;
      background-color: #f5f5f5;
      padding: 6px;
      border-radius: 4px;
      border-left: 3px solid #2196f3;

      .media-thumb {
        width: 30px;
        height: 30px;
        border-radius: 4px;
        margin-right: 6px;
      }
    }
  }
}

.pagination-controls {
  .pagination-info {
    flex: 1;
  }

  .pagination-buttons {
    display: flex;
    align-items: center;

    .v-btn {
      margin: 0 2px;
    }
  }
}
</style>
